// extracted by mini-css-extract-plugin
export default {"actionsContainer":"actions-module___actionsContainer___f348fac8","goBackButton":"actions-module___goBackButton___cecc8df3"};